import {
    Card,
    Loading,
    BaseTable,
    TableHeader,
    Button,
    Modal,
    Input,
    Textarea,
    ActionButton,
    Select,
} from "components"
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  TimeScale
} from "chart.js";
import "chartjs-adapter-date-fns";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { useProfileDetail } from "../utils/useProfileDetail"
import moment from "moment"
import { useEffect, useState } from "react"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import {  useApi, useToggle } from "utils"
import { PictureType } from "../types/EmediaTypes";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useProjectFileCode } from "../utils/useProjectFileCode";
import { useProjectFileList } from "../utils/useProjectFileList";
import toast from "react-hot-toast";
import { IoIosEye } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { useBoqDetail } from "../utils/useBoqDetail";

interface TabProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    TimeScale,
    ChartDataLabels
);

export function TabEmedia(props:TabProps): JSX.Element {
    const [isLoading , setLoading] = useState(true)
    const api = useApi();
    const { data } = useProfileDetail(props.project_id)
    const { dataFile, refetchList } = useProjectFileList(props.project_id!)
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)
    const {code , refetchCode} = useProjectFileCode()
    const dataBOQ = useBoqDetail(String(props?.project_id!))
    console.log(dataBOQ?.dropdownBoq)


    const { REACT_APP_BASE_URL_API } = process.env
    const [modalConfig, setModalConfig] = useState<any>({ show: false, type: "", data: {} })
    // const [searchResults, setSearchResults] = useState<any>(dataPicture);
    const [fileValue, setFileValue] = useState<File | undefined>(undefined);
    const { isActive, toggle } = useToggle(false)
    const [imageDetail, setImageDetail] = useState<string | null>()
    const [preview, setPreview] = useState<string | null>(null);


    useEffect(() => {
        if (isLoading && ((!data || data.length === 0) || !dataFile)) return;

        setDataProfile(data[0])
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );

        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)
        dataBOQ.refetchBoq()
        // eslint-disable-next-line
    },[data])

    const pictureValues: PictureType = {
        project_id:Number(props.project_id),
        project_boq_id: null,     
        project_file_id: null,     
        project_file_code: code ?? "",//pictureCode?.productpicturecode ?? "",
        project_file_name: "",
        description: "",
        project_file: "",
        path:null
    }
    const validationSchema = yup.object().shape({
        project_id: yup.number().required(),
        project_file_id: yup.number().nullable().optional(),
        project_file_code: yup.string().label("File code").required(),
        project_file_name: yup.string().label("File name").required(),
        description: yup.string().nullable().defined(),
        path: yup.string().optional().nullable()
    })
    const methods = useForm<PictureType>({ 
        defaultValues: pictureValues,
        resolver: yupResolver(validationSchema)
    })
    const { control, setValue } = methods;

    const openModal = async () => {
        const newCode = await refetchCode(); // DAPAT CODE BARU
    
        methods.reset({
            project_id:Number(props.project_id),
            project_file_id: null,
            project_boq_id: null,
            project_file_code: newCode ?? "",
            project_file_name: "",
            description: "",
            project_file: "",
            path: null
        });

        setFileValue(undefined);
    
        setModalConfig({ show: true, type: "CREATE", data: {} });
    };

    const openUpdateModal = (item:PictureType) => {

        methods.reset({
            project_id: Number(props.project_id),
            project_boq_id: item.project_boq_id,
            project_file_id: item.project_file_id,
            project_file_code: item.project_file_code,
            project_file_name: item.project_file_name,
            description: item.description,
            path: item.path
        });
    
        setModalConfig({ show: true, type: "UPDATE", data: item });
    };

    const onSubmit = (value: PictureType) => {
        const formData = new FormData();
        
        if(modalConfig?.type === "UPDATE" && modalConfig?.data?.project_file_id){formData.append('project_file_id', modalConfig?.data?.project_file_id)}
        formData.append('project_id', props.project_id!);
        if(value?.project_boq_id !== null) formData.append('project_boq_id', String(value?.project_boq_id));
        formData.append('project_file_code', value?.project_file_code);
        formData.append('project_file_name', value?.project_file_name);
        formData.append('description', value?.description ?? '');
        if (fileValue) { formData.append("project_file", fileValue) }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/project/project-file", formData),
                {
                loading: "Loading...",
                success: (res) => res.data.message,
                error: (err) => {
                    if (err.response && err.response.status === 402) {
                        return err.response.data.message || "Bad Request";
                    } else {
                        return "An error occurred";
                    }
                }
                }
            )
            .then(() => {
                methods.reset();
                setFileValue(undefined);
                setPreview(null)
                setModalConfig({ ...modalConfig, show: false });
            })
            .catch(() => {})
            .finally(() => {
                resolve()
                refetchList() 
            })
        })
    }

    const isImage = (filename: string | null | undefined) => {
        if (!filename) return false; // kalau null/undefined → otomatis bukan image
        
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
    };

    const selectedImage = (value: string | null | undefined) => {
        setImageDetail(value)
        toggle()
    }

    if(isLoading) return (
        <Loading
        loading={isLoading}
        errorText="No data available"
      />
    )

    return(
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                    
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                
                    </Card.Body>
                </Card>
            </section>

            <section>
                <Card>
                    <Card.Body>
                        <div className="w-full max-h-[calc(100vh-470px)]">
                            <div className="lg:flex overflow-x-auto">
                                <div className="flex"></div>
                                <div className="flex">
                                    <div>
                                        <Button className="bg-primary" permission="SUBSCRIBED" onClick={openModal} disabled={!Boolean(dataBOQ?.dropdownBoq?.length > 0)}>
                                            ADD FILE
                                        </Button>

                                        {!Boolean(dataBOQ?.dropdownBoq?.length > 0) && (
                                          <div className="text-error"><small>There is no BOQ for this project yet. Add lines in the <b>BOQ</b> tab before you can upload files.</small></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                        {modalConfig?.show && code &&
                            
                            <Modal 
                                isOpen 
                                title={`${modalConfig?.type === "CREATE" ? "INSERT" : modalConfig?.type === "UPDATE" ? "UPDATE" : "DETAIL"} FILE`} 
                                size="xl" 
                                closeModal={() => {
                                    methods.reset({
                                        project_id:Number(props.project_id),
                                        project_file_id: null,
                                        project_boq_id: null,
                                        project_file_code: "",
                                        project_file_name: "",
                                        description: "",
                                        project_file: "",
                                        path: null
                                    });
                                
                                    // RESET FILE & IMAGE
                                    setFileValue(undefined);
                                    setPreview(null);
                                    setModalConfig({ ...modalConfig, show: false })
                                    
                                }}
                            >
                                <form onSubmit={methods.handleSubmit(onSubmit)}>
                                    <Modal.Body>
                                        
                                            <section className="grid md:grid-cols-2 gap-3">
                                                <section>
                                                    <Controller
                                                        control={control}
                                                        name="project_file_code"
                                                        render={({ field, fieldState }) => 
                                                            <Input
                                                                {...field} 
                                                                label="ID FILE" 
                                                                value={field.value}
                                                                error={fieldState.error?.message} 
                                                                disabled
                                                            />
                                                        }
                                                    />
                                                    <Controller
                                                        control={control}
                                                        name="project_file_name"
                                                        render={({ field, fieldState }) => 
                                                            <Input 
                                                                {...field} 
                                                                label="FILE NAME" 
                                                                value={field.value ?? ""} 
                                                                onChange={(e) => setValue("project_file_name", e?.target?.value)}
                                                                error={fieldState.error?.message} 
                                                                disabled={modalConfig?.type === "DETAIL" ? true : false}
                                                            />
                                                        }
                                                    />
                                                    <Controller
                                                    control={control}
                                                    name="description"
                                                    render={({ field, fieldState }) => 
                                                        <Textarea 
                                                            {...field} 
                                                            label="DESCRIPTION" 
                                                            value={field.value ?? ""} 
                                                            onChange={(e) => setValue("description", e?.target?.value)}
                                                            error={ fieldState.error?.message} 
                                                            disabled={modalConfig?.type === "DETAIL" ? true : false}
                                                        />
                                                    }
                                                    />
                                                    <Controller
                                                      control={control}
                                                      name="project_boq_id"
                                                      render={({ field }) => {
                                                        return (
                                                          <Select
                                                            label="BOQ"
                                                            className="w-full"
                                                            placeholder="Select BOQ"
                                                            options={dataBOQ?.dropdownBoq}
                                                            value={field.value ? dataBOQ?.dropdownBoq?.find((item) => Number(item.value) === field.value) : null}
                                                            onChange={(e) => field.onChange(e?.value)}
                                                          />
                                                        )
                                                      }}
                                                    />
                                                </section>


                                                <section>
                                                    {/* UPLOAD BUTTON (Hanya untuk CREATE & UPDATE) */}
                                                    {modalConfig?.type !== "DETAIL" && (
                                                        <div className="relative w-full h-[50px] bg-primary rounded-lg flex items-center justify-center cursor-pointer">
                                                            <Controller
                                                                control={control}
                                                                name="project_file"
                                                                render={({ field }) => (
                                                                    <input
                                                                        type="file"
                                                                        className="absolute inset-0 opacity-0 cursor-pointer"
                                                                        onChange={(e) => {
                                                                            const selectedFile = e.target.files?.[0];

                                                                            if (selectedFile) {
                                                                                if (selectedFile.size > 1000 * 100 * 1024) {
                                                                                    alert("File size maximum 100MB");
                                                                                    return;
                                                                                }

                                                                                setFileValue(selectedFile);
                                                                                field.onChange(selectedFile);

                                                                                const reader = new FileReader();
                                                                                reader.onloadend = () => {
                                                                                    const result = reader.result;

                                                                                    if (typeof result === "string") {
                                                                                        setPreview(result);
                                                                                    } else {
                                                                                        setPreview(null);
                                                                                    }
                                                                                };
                                                                                reader.readAsDataURL(selectedFile);
                                                                            } else {
                                                                                setFileValue(undefined);
                                                                                setPreview(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            <b className="text-black">
                                                                {modalConfig?.type === "UPDATE" ? "UPDATE" : "ADD"} FILE
                                                            </b>
                                                        </div>
                                                    )}

                                                    {/* FILE NAME */}
                                                    {fileValue && (
                                                        <div className="mt-2 text-sm font-semibold">{fileValue.name}</div>
                                                    )}

                                                    {/* PREVIEW AREA */}
                                                    <div className="mt-3">
                                                        {preview ? (
                                                            // IF NEW UPLOADED FILE IS IMAGE
                                                            preview.startsWith("data:image") ? (
                                                                <img
                                                                    src={preview}
                                                                    alt="Preview"
                                                                    className="w-[250px] rounded-lg object-contain border"
                                                                />
                                                            ) : (
                                                                // IF NEW UPLOADED FILE IS NOT IMAGE
                                                                <IoDocumentTextOutline size={80} color="#555" />
                                                            )
                                                        ) : modalConfig?.data?.path ? (
                                                            // IF FILE EXIST ON SERVER
                                                            modalConfig.data.path.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                                                <img
                                                                    src={`${REACT_APP_BASE_URL_API}/getimage/?imgpath=${modalConfig.data.path}&t=${Date.now()}`}
                                                                    className="w-[250px] rounded-lg object-contain border"
                                                                    alt="Existing File"
                                                                />
                                                            ) : (
                                                                <IoDocumentTextOutline size={80} color="#555" />
                                                            )
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>

                                                    {/* VIEW BUTTON */}
                                                    {modalConfig?.data?.path && (
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                window.open(
                                                                    `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${modalConfig.data.path}&t=${Date.now()}`,
                                                                    "_blank"
                                                                )
                                                            }
                                                            className="flex items-center gap-2 hover:text-blue-800 mt-3 ms-3"
                                                        >
                                                            <IoIosEye size={28} /> Lates Uploaded File
                                                        </button>
                                                    )}
                                                </section>

                                            </section>
                                        
                                    </Modal.Body>

                                    <Modal.Footer className="text-end">
                                        <Button type="submit" color="primary">
                                            Save
                                        </Button>
                                    </Modal.Footer>
                                </form>
                            </Modal>
                        }

                        <div className="overflow-x-auto">
                            <BaseTable className="border-collapse">
                            <TableHeader>
                                <tr>
                                <th>NO</th>
                                <th>BOQ</th>
                                <th>FILE</th>
                                <th>FILE ID</th>
                                <th>NAME</th>
                                <th>DESCRIPTION</th>
                                <th>FILE PATH</th>
                                <th>ACTION</th>
                                </tr>
                            </TableHeader>
                            <tbody>
                               {dataFile.map((item, index) => {
                                    return(
                                        <tr key={index} >
                                            <td className="text-center">{index+1}</td>
                                            <td>{item?.project_boq_id ? dataBOQ?.dropdownBoq?.find(boq => Number(boq?.value) === item?.project_boq_id)?.label : "-"}</td>
                                            <td className="text-center">
                                            {isImage(item?.path) ? (
                                                <img
                                                    onClick={() => selectedImage(item?.path)}
                                                    src={`${REACT_APP_BASE_URL_API}/getimage/?imgpath=${item?.path}&t=${Date.now()}`}
                                                    alt="preview"
                                                    className="cursor-pointer object-contain max-h-[100px] mx-auto"
                                                />
                                            ) : (
                                                <div className="w-full flex items-center justify-center hover:text-blue-800">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.open(
                                                                `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${item?.path}&t=${Date.now()}`,
                                                                "_blank"
                                                            )
                                                        }
                                                    >
                                                        <IoDocumentTextOutline 
                                                            size={50} 
                                                            className="mx-auto text-gray-600 cursor-pointer"
                                                        />
                                                    </button>
                                                 </div>
                                            )}
                                        </td>
                                            <td className="">{item.project_file_code}</td>
                                            <td className="">{item.project_file_name}</td>
                                            <td className="">{item.description}</td>
                                            <td>{item.path ?? ""}</td>
                                            <td>
                                                <ActionButton.Update onClick={() => {
                                                   openUpdateModal(item)
                                                }} />
                                                <ActionButton.Delete onClick={() => {
                                                    item?.project_file_id && 
                                                    api.delete(`/project/delete-project-file?project_file_id=${item?.project_file_id}`)
                                                    .then(() => refetchList())
                                                }} />
                                            </td>
                                        </tr>
                                    )
                                })}
                               
                            </tbody>
                            </BaseTable>
                        </div>

                    </Card.Body>
                </Card>
            </section>

            {isActive && <DetailImage toggle={toggle} image={imageDetail} />}
            
        </section>
    )
}


function DetailImage(props: {
    toggle: () => void,
    image: string | undefined|null
}) {
    const { REACT_APP_BASE_URL_API } = process.env
    return (
        <Modal isOpen title='' closeModal={props.toggle}>
            <Modal.Body>
                <img src={`${REACT_APP_BASE_URL_API}/getimage/?imgpath=${props?.image}`} alt="" className='h-full' />
            </Modal.Body>
        </Modal>
    )
}